const sortByReferenceIds = (objects: any, referenceIds: any) => {
  // if referenceIds is null, no need to sort
  if (referenceIds === null || referenceIds === undefined) return objects;
  return [...objects].sort((a, b) => {
    // added spread/slice to create mutable version of objects
    if (referenceIds === null) return 0; // keep order unchanged
    const indexA = referenceIds.indexOf(a.id);
    const indexB = referenceIds.indexOf(b.id);

    // Handle missing IDs in the reference array
    if (indexA === -1 && indexB === -1) {
      return 0; // Keep the order unchanged
    } else if (indexA === -1) {
      return 1; // Move object without reference ID to the end
    } else if (indexB === -1) {
      return -1; // Move object with reference ID before others
    }
    return indexA - indexB;
  });
};

export default sortByReferenceIds;
